import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";

const GAHER_TESTIMONIAL = {
  id: "laboratorios-gaher",
  comentario: "Llegamos a ellos recomendados por un amigo y nuestras expectativas eran muy altas. No solo las cumplieron, sino que lograron superarlas. Estamos plenamente satisfechos con su trabajo y, por eso, los recomendamos con total confianza.",
  nombre: "Laboratorios Gaher S.A.",
  cargo: "",
  empresa: "",
  servicio: "",
};

export default function Testimonials() {
  const active = GAHER_TESTIMONIAL;

  return (
    <section id="testimonios" className="relative py-24 md:py-36 border-t border-[#1A1A1A]/10 bg-[#1A1A1A] text-[#F9F6F0]" data-testid="testimonials-section">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <Reveal>
          <div className="eyebrow text-[#F9F6F0]/60 mb-6">— 08 · Testimonios</div>
          <h2 className="display-2">Lo que dicen <em className="italic text-[#F9F6F0]/70">nuestros clientes</em>.</h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-12 gap-6 items-start min-h-[280px]">
          <div className="col-span-12 md:col-span-2">
            <Quote className="w-16 h-16 md:w-24 md:h-24 text-[#F9F6F0]/25" strokeWidth={0.5} />
          </div>
          <div className="col-span-12 md:col-span-10">
            <motion.blockquote
              key={active.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.55, ease: [0.76, 0, 0.24, 1] }}
              className="font-serif italic text-2xl md:text-4xl lg:text-5xl leading-[1.2] tracking-[-0.01em] text-[#F9F6F0]"
              data-testid="testimonial-quote"
            >
              “{active.comentario}”
              <footer className="mt-10 not-italic font-sans text-sm text-[#F9F6F0]/70">
                {(active.cargo || active.nombre) && (
                  <div className="font-medium text-[#F9F6F0]">{active.cargo || active.nombre}</div>
                )}
                {(active.empresa || active.servicio) && (
                  <div>{[active.empresa, active.servicio].filter(Boolean).join(" · ")}</div>
                )}
              </footer>
            </motion.blockquote>
          </div>
        </div>

      </div>
    </section>
  );
}
